import { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = checking, false = logged out
  const [company, setCompany] = useState(null);

  const loadCompany = async () => {
    try {
      const { data } = await api.get("/company");
      setCompany(data);
    } catch (_) {}
  };

  useEffect(() => {
    // CRITICAL: returning from Google OAuth — let AuthCallback exchange the session_id first.
    if (window.location.hash?.includes("session_id=")) {
      return;
    }
    const token = localStorage.getItem("aim_token");
    if (!token) {
      setUser(false);
      return;
    }
    api.get("/auth/me")
      .then(({ data, headers }) => {
        if (headers["x-refresh-token"]) localStorage.setItem("aim_token", headers["x-refresh-token"]);
        setUser(data);
        loadCompany();
      })
      .catch(() => {
        localStorage.removeItem("aim_token");
        setUser(false);
      });
  }, []);

  const login = (token, u) => {
    localStorage.setItem("aim_token", token);
    setUser(u);
    loadCompany();
  };

  const logout = async () => {
    try {
      await api.post("/auth/logout");
    } catch (_) {}
    localStorage.removeItem("aim_token");
    setUser(false);
    setCompany(null);
    window.location.href = "/login";
  };

  // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
  const loginWithGoogle = () => {
    const redirectUrl = window.location.origin + "/app/dashboard";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <AuthContext.Provider value={{ user, company, setCompany, login, logout, loginWithGoogle, refreshCompany: loadCompany }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);

export const ROLE_LABELS = {
  super_admin: "Super Admin",
  company_admin: "Company Admin",
  manager: "Manager",
  employee: "Employee",
  read_only: "Read Only",
  corporate_manager: "Corporate Manager",
};
export const isCorporate = (role) => role === "corporate_manager";
export const homeRoute = (role) => (role === "corporate_manager" ? "/app/corporate" : "/app/dashboard");

export const canWrite = (role) => ["super_admin", "company_admin", "manager", "employee"].includes(role);
export const canManage = (role) => ["super_admin", "company_admin", "manager"].includes(role);
export const isAdmin = (role) => ["super_admin", "company_admin"].includes(role);
